<script lang="ts" setup>
import type { GameItem } from '@kira-dancer/nuxt-common'
import { useCustomRecentGame } from '~/composables/account/use-custom-recent-game'
import { RoutesEnum } from '~/enums'
import { GAME_DEFAULT, HOME_SWIPER_OPTIONS } from '~/resources'

const maxDisplayedGames = 4

const { allRecentGameDisplay, isEmpty } = useCustomRecentGame()

const isSwiperLoaded = ref(false)

const swiperOptions = {
  ...HOME_SWIPER_OPTIONS,
  loop: false,
  slidesPerView: 2.5,
  spaceBetween: 12,
}

const { navigate } = useNavigate()

const isShowMoreBtn = computed((): boolean => {
  return allRecentGameDisplay.value.length >= maxDisplayedGames
})

const displayGameRecent = computed((): GameItem[] => {
  let totalRemainingGames = 0
  const maxDefaultItem = 3
  const allRecentGames = allRecentGameDisplay.value.slice(0, 6)

  if (allRecentGames.length <= maxDefaultItem) {
    totalRemainingGames = maxDefaultItem - allRecentGames.length

    const newRecentGames = Array(totalRemainingGames).fill(GAME_DEFAULT)
    allRecentGames.push(...newRecentGames)
  }

  return allRecentGames
})

const onSwiper = () => {
  isSwiperLoaded.value = true
}
</script>

<template>
  <div v-if="!isEmpty" class="recent-game-section">
    <BaseSection title="Chơi gần đây" icon="icon-recent">
      <div class="recent-game-section__content">
        <BaseSwiper
          v-show="isSwiperLoaded"
          :items="displayGameRecent"
          :options="swiperOptions"
          :on-swiper="onSwiper"
        >
          <template #item="{ item }: { item: GameItem }">
            <CommonGameItem
              :class="{
                'recent-game-section__placeholder-item': !item.ID,
              }"
              :item="item"
              :is-coming-soon="item?.gameType === 'default'"
            />
          </template>
        </BaseSwiper>

        <div
          v-show="!isSwiperLoaded"
          class="recent-game-section__placeholder-games"
        >
          <CommonGameItem
            v-for="item in displayGameRecent"
            :key="item.ID"
            :item="item"
            :is-coming-soon="item?.gameType === 'default'"
          />
        </div>
      </div>
      <template v-if="isShowMoreBtn" #right-action>
        <BaseButton
          label="Xem thêm"
          size="small"
          variant="text"
          button-id="load-more-game"
          button-name="load-more-game"
          @click="navigate(RoutesEnum.RecentPlayedGames)"
        />
      </template>
    </BaseSection>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/styles/components/mobile/home/recent-game.scss';
</style>
